
import React from "react";
import Typography from "@mui/material/Typography";
import Moment from "moment";
import { Paper } from "@mui/material";
import { useNavigate } from "react-router";
import { useTheme } from "@mui/material/styles";
import { DataGridPro } from "@mui/x-data-grid-pro";
import Box from "@mui/material/Box";

const columns = [
    { field: 'friendlyId', headerName: 'Number', headerClassName: 'quotes-theme--header', cellClassName: 'hyperlink', flex: 1, minWidth: 140 },
    { field: 'jobNumber', headerName: 'Job No.', headerClassName: 'quotes-theme--header', flex: 1, valueFormatter: (value) => value || '-' },
    { field: 'quoteStatus', headerName: 'Status', headerClassName: 'quotes-theme--header', flex: 1 },
    { field: 'createdAt', headerName: 'Created At', headerClassName: 'quotes-theme--header', flex: 1.5, valueFormatter: (value) => Moment(value).format('D MMM YYYY, h:mma') },
];

const ClientQuotesView = ({ quotes }) => {
    const navigate = useNavigate();
    const theme = useTheme();

    const handleRowClick = (params) => {
        navigate(`/projects/${params.id}`);
    };

    return (
        <Paper className="paper-rounded-edges" sx={{ overflow: 'hidden' }}>
            <Typography variant="h6" color="white" sx={{ backgroundColor: theme.palette.primary.secondary, p: 1 }}>
                Projects
            </Typography>
            <Box
                sx={{
                    height: 473,
                    '& .MuiDataGrid-row:hover': { cursor: 'pointer' },
                    '& .quotes-theme--header': { color: 'white' },
                    '& .MuiDataGrid-main': { mt: 0 },
                    '& .MuiDataGrid-columnHeadersInner': { mt: 0 },
                    '& .MuiDataGrid-withBorderColor': { borderTop: 'none' },
                }}
            >
                <DataGridPro
                    rows={quotes}
                    columns={columns}
                    onRowClick={handleRowClick}
                    initialState={{
                        density: 'compact',
                    }}
                    hideFooter
                    disableRowSelectionOnClick
                    sx={{
                        borderRadius: 0,
                        border: 'none',
                        '& .MuiDataGrid-columnHeaders': {
                            borderRadius: 0,
                        },
                    }}
                    slotProps={{
                        loadingOverlay: {
                            variant: 'skeleton',
                            noRowsVariant: 'skeleton',
                        },
                    }}
                />
            </Box>
        </Paper>
    );
};

export default ClientQuotesView;